export default {"src":"/_next/static/media/share-solid.f8562282.svg","height":512,"width":512};